export const SET_RANGE = 'stats/overview/CHANGE_RANGE';
export const setRange = range => ({ type: SET_RANGE, range });

export const CHANGE_PAGE = 'stats/reports/CHANGE_PAGE';
export const changePage = page => ({ type: CHANGE_PAGE, page });

export const TOGGLE_SORT_DIRECTION = 'stats/reports/TOGGLE_SORT_DIRECTION';
export const toggleSortDirection = () => ({ type: TOGGLE_SORT_DIRECTION });

export const CHANGE_PAYOUTS_PAGE = 'stats/reports/CHANGE_PAYOUTS_PAGE';
export const changePayoutsPage = payoutsPage => ({ type: CHANGE_PAYOUTS_PAGE, payoutsPage });

export const SET_SELECTED_PAYOUT = 'stats/reports/SET_SELECTED_PAYOUT';
export const setSelectedPayout = payout => ({ type: SET_SELECTED_PAYOUT, payout });

export const initialState = {
  range: 4, // in weeks
  page: 1,
  sortDirection: 'dsc',
  payoutsPage: 1,
  selectedPayout: null,
};

const reducer = (state = initialState, { type, ...action }) => {
  switch (type) {
    case SET_RANGE:
      return { ...state, range: action.range };
    case CHANGE_PAGE:
      return { ...state, page: action.page };
    case TOGGLE_SORT_DIRECTION:
      return { ...state, sortDirection: state.sortDirection === 'dsc' ? 'asc' : 'dsc' };
    case CHANGE_PAYOUTS_PAGE:
      return { ...state, payoutsPage: action.payoutsPage };
    case SET_SELECTED_PAYOUT:
      return { ...state, selectedPayout: action.payout };
    default:
      return state;
  }
};

export default reducer;
